import { cn } from 'lib/utils';
import { Pause, Play } from 'lucide-react';
import { useRef, useState } from 'react';

interface voiceCardProps {
  name: string;
  img: string;
  preview: string;
  setSelected: (value: { name: string; gender: 'M' | 'F' }) => void;
  selected: {
    name: string;
    gender: 'M' | 'F';
  };
  gender: 'M' | 'F';
}

const VoiceCard = ({
  name,
  img,
  preview,
  setSelected,
  selected,
  gender,
}: voiceCardProps) => {
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const handlePlay = () => {
    // creating the ref instance if it does not exist
    if (!audioRef.current) {
      audioRef.current = new Audio(preview); //  stores the Audio instance in the ref. This allows the instance to persist across re-renders of the component.

      // used ref as we can access the different stages which wont be possible in const audio = new Audio()
      audioRef.current?.addEventListener('play', () => setIsPlaying(true));
      audioRef.current?.addEventListener('pause', () => setIsPlaying(false));
      audioRef.current?.addEventListener('ended', () => setIsPlaying(false));
    }

    if (audioRef.current) {
      // Safely access audioRef.current
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
    }
  };

  return (
    <div
      className={cn(
        'flex flex-row items-center justify-between w-full sm:w-[232px] h-12 bg-background-card text-text-primary rounded-md',
        selected.name === name ? 'border-2 border-primary' : ''
      )}
    >
      {/* image */}
      <div
        className={`flex flex-row gap-2 items-center border-2 w-[80%] h-12 ${isPlaying ? 'border-primary' : 'border-secondary'} rounded-l-md pl-2 cursor-pointer ${selected?.name === name ? 'border-primaryAccent-9' : 'border-[#D7DAD9]'}`}
        onClick={() => setSelected({ name: name, gender: gender })}
      >
        <div className="h-9 w-9">
          <div className="relative h-full w-full overflow-hidden rounded-md">
            <img
              src={img}
              alt="profile-img"
              className="h-full w-full object-cover"
            />
          </div>
        </div>

        <p className=" font-semibold text-[16px]">{name}</p>
      </div>
      {/* play button */}
      <div className="bg-primaryAccent-9 h-full flex items-center justify-center rounded-r-md w-[20%]">
        {isPlaying ? (
          <Pause
            size={18}
            color="#FFFFFF"
            className="cursor-pointer"
            onClick={handlePlay}
            style={{ opacity: isPlaying ? 1 : 0.6 }}
          />
        ) : (
          <Play
            size={18}
            color="#FFFFFF"
            className="cursor-pointer"
            onClick={handlePlay}
            style={{ opacity: isPlaying ? 1 : 0.6 }}
          />
        )}
      </div>
    </div>
  );
};

export default VoiceCard;
